import { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";


const CountryCodePhoneSelect = ({data, setData}) => {

    const [selected, setSelected] = useState("AT");

    const selectData = {
        countries: [
            'AT', 'BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'HR', 'IT', 'CY', 'LV',
            'LT', 'LU', 'HU', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'GB',
        ],
        labels: {
            AT: '+43', BE: '+32', BG: '+359', CZ: '+420', DK: '+45', DE: '+49', EE: '+372', IE: '+353',
            EL: '+30', ES: '+34', FR: '+33', HR: '+385', IT: '+39', CY: '+357', LV: '+371', LT: '+370',
            LU: '+352', HU: '+36', MT: '+356', NL: '+31', NO: '+47', PL: '+48', PT: '+351', RO: '+40', 
            SI: '+386', SK: '+421', FI: '+358', SE: '+46', GB: '+44',
        }
    }

    useEffect(() => {
        return setSelected(Object.keys(selectData.labels).find(
            (key) => selectData.labels[key] === data.phone_country
        ));
    }, [data.phone_country])

    const selectHandler = (code) => {
        setData(prev => ({...prev, phone_country: selectData.labels[code]}));
    }

    return (
        <div className="text-dark">
            <ReactFlagsSelect
                searchable
                countries={selectData.countries}
                customLabels={selectData.labels}
                onSelect={code => selectHandler(code)}
                selected={selected}
            />
        </div>
    )
}

export default CountryCodePhoneSelect;